export class RepFillRate {   
    Fecha : string;
    Valor: string;
    UnidadesSolicitadas: number;
    PedidosSolicitados: number;
    UnidNegoDescripcion: string;
    Data: Array<FillRate>;
    }

export class FillRate {
    Fecha : string;
    FechaUpdate : string;
    Valor : string;
}

   